import { createFileRoute } from "@tanstack/react-router";

/**
 * `?tab=` là thẻ đang mở (xem features/orders/orderTabs.ts). Giá trị lạ được tha — hook tự về mặc định.
 * `?note=` là ghi chú cần cuộn tới + nháy viền — chuông @nhắc tên mở `?tab=note&note=<id>` (QĐ 0256).
 */
type OrderDetailSearch = { tab?: string | undefined; note?: string | undefined };

export const Route = createFileRoute("/_app/orders/$orderId")({
  validateSearch: (search: Record<string, unknown>): OrderDetailSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
    note: typeof search.note === "string" ? search.note : undefined,
  }),
});
